
export default {
  name: 'mode',
  state: {
    sidebarShow: false,
    darkMode: false,
    helpEnabled: false,
    helpShown: false,
    helpContent: { title: "Help", body: "Here is help." },
    eventLogDetailViewState: false,
    snackbar: false,
    snackBarText: '',
    snackBarStatus: null,
    sidebarMinimize: false,
  },
  mutations: {
    set(state, [variable, value]) {
      state[variable] = value
    },
    toggle(state, variable) {
      state[variable] = !state[variable]
    },
  }
}
